import {gsap, ScrollTrigger} from "gsap/all";

gsap.registerPlugin(ScrollTrigger);


// Timeline gsap
let timeline = gsap.timeline({paused:true});
let text_intro = null;
var max_x_first_image = null;
var distance_titre_photo = null;
let images_mask_projects = null;
let half_viewportWidth = null;
let viewportWidth = null;
let currentPageX = null;
let currentPageY = null;
/**
 * Fonction lancé au scroll du slider
 * @param progress
 */
const updateTimeline = () => {
    updateIntro();
    updateOutro();
    updateCopyRight();
    updateProjects();
}

const triggerMouseMove = () => {
    var event = $.Event('mousemove');
    event.pageX = currentPageX;
    event.pageY = currentPageY;
    $(document).trigger(event);
}
/**
 * On regarde la position des images pour voir si on affiche ou on cache le texte d'intro
 */
const updateIntro = () => {
    if (max_x_first_image) {
        var left = $("#img-section-1").offset().left;
        var right = text_intro.offset().left + text_intro.width() - 50;
        var diff = left - right;
        var pcent = diff / distance_titre_photo;
        // // console.log(pcent);
        if (pcent < 0) {
            pcent = 0;
        }
        if (pcent > .7) {
            pcent = 1;
        }
        text_intro.css('opacity', pcent);
        // gsap.to("#h-scroll-wrapper section.w1", {autoAlpha:pcent,duration:.3, ease:"power1.out"})
    } else {
        max_x_first_image = $("#img-section-1").offset().left;
        var right = text_intro.offset().left + text_intro.width();
        distance_titre_photo = max_x_first_image - right + 10; // on rajoute 2à de marge
        // // console.log("Distance titre photo : " + distance_titre_photo);
    }


}

/**
 * On regarde la position des images pour voir si on affiche ou on cache l'outro
 */
const updateOutro = () => {
    var lastmaskImag = $("#h-scroll-wrapper section.img-section:last .mask-image");
    var bordDroit = lastmaskImag.width() + lastmaskImag.offset().left;
    if (bordDroit <= half_viewportWidth) {
        let pcent = bordDroit / half_viewportWidth;
        if (pcent < 0.5) {
            pcent = 0;

        }
        if (pcent > .95) {
            pcent = 1;
        }
        // // console.log(pcent);
        var val = 1 - pcent;
        gsap.to("#slider-last-slide-content, #container-trailer-image-1", {autoAlpha: val, ease: "power0.easeIn", duration: .3})
    }else{
        gsap.to("#slider-last-slide-content, #container-trailer-image-1", {autoAlpha: 0, ease: "power0.easeIn", duration: .3})
    }
}


/**
 * On regarde la position de la dernière image pour afficher le copyright
 */
const updateCopyRight = () => {
    var lastmaskImag = $("#h-scroll-wrapper section.img-section:last .mask-image");
    var bordDroit = lastmaskImag.width() + lastmaskImag.offset().left;
    var startAppearing = 70;
    if (bordDroit <= startAppearing) {
        let pcent = bordDroit / startAppearing;
        if (pcent < 0.5) {
            pcent = 0;
        }
        if (pcent > .95) {
            pcent = 1;
        }
        var val = 1 - pcent;
        gsap.to("#footer-hp-wrapper", {autoAlpha: val, ease: "power0.easeIn", duration: .3})
    }

}

/**
 * On regarde la position des images pour mettre à jour la position de la photo à l'intérieur du masque
 */
const updateProjects = () => {
    /*var event = $.Event('mousemove');
    event.pageX = currentPageX;
    event.pageY = currentPageY;
    $(document).trigger(event);*/

    images_mask_projects.each(function (index) {
        var mask = $(this),
            mask_width = mask.width(),
            img = mask.find("img.img-project"),
            link = mask.find("a"),
            img_width = img.width(),
            maskCenterX = mask_width / 2 + mask.offset().left,
            delta = img_width - mask_width,
            pcent = maskCenterX * 100 / viewportWidth,
            decalage = pcent * delta / 100;
        if (decalage < 0) {
            decalage = 0;
        }
        if (decalage > delta) {
            decalage = delta;
        }
        gsap.to(img, {x: (-1 * decalage), ease: "power0.easeIn", duration: .3, delay: index * 0.051, onComplete:triggerMouseMove})


        // //console.log( decalage );
    });
}

const moveProjectName = (e) => {
    currentPageX = e.pageX;
    currentPageY = e.pageY;
    var descProject = $("#desc-project"),
        widthDesc = descProject.width(),
        heightDesc = descProject.height();
    gsap.to("#desc-project", {
        ease:"Power1.easeout",
        x: e.pageX - (widthDesc / 2),
        y: e.pageY - (heightDesc / 2) - $(window).scrollTop()
    });
}

function init_home_slider() {
    (function ($) {
        $(document).ready(function () {
            //console.log("Init du slider de la home");
            $('body').addClass('home-slider');
            let sections = gsap.utils.toArray("#h-scroll-wrapper section.move");
            text_intro = $("#h-scroll-wrapper section.w1 h2");
            let container = document.querySelector("#h-scroll-wrapper");
            // let images = gsap.utils.toArray(document.querySelectorAll("#h-scroll-wrapper section.move .mask-image img"));
            images_mask_projects = $("#h-scroll-wrapper section.img-section .mask-image");
            viewportWidth = $("body").innerWidth();
            half_viewportWidth = viewportWidth / 2;

            images_mask_projects.find("a").on('mouseover', function () {
                // write project code name and short desc in #desc-project div
                let projectName = $(this).next(".project-name").children(".project-code-name").text(),
                    projectDesc = $(this).next(".project-name").children(".project-description").text();

                $("#desc-project .project-code-name").text(projectName);
                $("#desc-project .project-description").text(projectDesc);
                $(this).on('mousemove', function (e) {
                    moveProjectName(e);
                })
                gsap.to("#desc-project", {autoAlpha: 1})
            }).on('mouseout', function () {
                gsap.to("#desc-project", {autoAlpha: 0})
            });

           // timeline.set(sections, {alpha:0, y:"-10%"})
            timeline.to(sections, {
                y: "0%", autoAlpha: 1, duration: 0.85, stagger: 0.15,  ease: "power3.out",  onComplete: () => {
                    max_x_first_image = $(sections[0]).offset().left;
                }
            })

                .to(sections, {
                    x: () =>
                        -(container.scrollWidth - document.documentElement.clientWidth) + "px",
                    ease: "power1.easeout",
                    duration: 0.1,
                    //delay: 2,
                    onUpdate: updateTimeline,
                    scrollTrigger: {
                        pin: true,
                        scrub: 1,
                        trigger: container,
                        end: () => container.scrollWidth - document.documentElement.clientWidth
                    }
                });
        });
    })(jQuery);
}

function desinit_home_slider() {
    // console.log("Desinit du slider de la home");
    $('body').removeClass('home-slider');

    var tweenTab = timeline.getChildren();
    $.each(tweenTab, function (index, value){
       value.eventCallback("onUpdate", null);
    });

    //timeline.eventCallback("onUpdate", null);
    timeline.clear(true);
    timeline.kill();
}

export {init_home_slider, desinit_home_slider, timeline};